import { webshopEnvironment } from "@akina/config";

export function pushGtmEvent(event: string, data?: Record<string, unknown>): void {
  if (!webshopEnvironment.gtmId) return;
  globalThis.dataLayer = globalThis.dataLayer ?? [];
  globalThis.dataLayer.push({ event, ...data });
}

export function initializeGtm(): void {
  const { gtmId } = webshopEnvironment;

  if (!gtmId) {
    if (webshopEnvironment.environment === "prod") {
      console.warn("[GTM] VITE_GTM_ID is not set — GTM will not load.");
    }
    return;
  }

  globalThis.dataLayer = globalThis.dataLayer ?? [];
  globalThis.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const loaderScript = document.createElement("script");
  loaderScript.id = "gtm-script";
  loaderScript.async = true;
  loaderScript.src = "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(gtmId) + "&l=dataLayer";

  document.head.appendChild(loaderScript);
}
